import { render, staticRenderFns } from "./ResultSummary.vue?vue&type=template&id=424dc3f0&scoped=true&"
import script from "./ResultSummary.vue?vue&type=script&lang=ts&"
export * from "./ResultSummary.vue?vue&type=script&lang=ts&"
import style0 from "./result-summary.scss?vue&type=style&index=0&id=424dc3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424dc3f0",
  null
  
)

export default component.exports